"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconLowAttention = function IconLowAttention(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconLowAttention', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm.675 10.083a.93.93 0 0 0-1.35 0 1.016 1.016 0 0 0 0 1.4.93.93 0 0 0 1.35 0 1.016 1.016 0 0 0 0-1.4zM8 3.863c-.527 0-.955.444-.955.99v3.96l.007.116c.055.492.458.874.948.874.527 0 .955-.443.955-.99v-3.96l-.007-.115c-.055-.492-.458-.874-.948-.874z"
  }));
};

var _default = IconLowAttention;
exports.default = _default;